export default {
  SET_ISSUER_AGREEMENTS(state, { data }) {
    state.issuerAgreementList = data;
  },
  SET_ISSUER_AGREEMENT(state, data) {
    state.activeIssuerAgreement = data;
  },
};
